import { Container, Typography, Card, CardContent, Avatar, Grid2 } from '@mui/material';
import arImage from '../images/ar.jpeg';


const Home = () => {
return (<Container maxWidth="md" sx={{ mt: 4 }}>
      <Grid2 container spacing={3} alignItems="center">
        <Grid2 xs={12} sm={4} display="flex" justifyContent="center">
          <Avatar
            alt="Andrea Ricci"
            src={arImage}
            sx={{ width: 150, height: 150 }}
          />
        </Grid2>
        <Grid2 xs={12} sm={8}>
          <Typography variant="h4" gutterBottom>
          Andrea Ricci – Full Stack Developer
          </Typography>
          <Typography variant="body1">
          Trasformo idee in soluzioni digitali: benvenuto nel mio spazio professionale.
          </Typography>
        </Grid2>
      </Grid2>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Esperienze Formative e Lavorative
      </Typography>
      <Card sx={{ mb: 2 }}>
  <CardContent>
    <Typography variant="h6">IT Specialist in Development of Cloud, Data and Graphics Applications</Typography>
    <Typography variant="body2" color="text.secondary">
      Ho una formazione avanzata in sviluppo di applicazioni cloud, dati e grafiche, conseguita presso ITS Umbria Academy. 
      Sono appassionato di tecnologie Microsoft e dello sviluppo software.  
      Durante il mio percorso formativo, ho acquisito una solida esperienza nello sviluppo di applicazioni con C# e .NET, 
      realizzando Console App, applicazioni WPF, Web API e progetti Unity, integrando logiche di gioco in C#.  
      Ho inoltre sviluppato competenze nella progettazione e gestione di database relazionali, utilizzando SQL per soluzioni efficienti e scalabili.  
      Ho conseguito il diploma EQF di V livello con la votazione di 89/100.
    </Typography>
  </CardContent>
</Card>
      
    

<Card sx={{ mb: 2 }}>
  <CardContent>
    <Typography variant="h6">Certificazione IBM - Full Stack Software Developer</Typography>
    <Typography variant="body2" color="text.secondary">
      Ho ottenuto la certificazione IBM Full Stack Software Developer, completando un percorso di 15 corsi focalizzati 
      sullo sviluppo di applicazioni cloud-native e sulle pratiche DevOps.  
      Durante il programma, ho acquisito competenze in sviluppo front-end con HTML, CSS, JavaScript e React, e back-end con Node.js, Express e Django, 
      utilizzando database relazionali (SQL) e NoSQL.  
      Ho approfondito l'uso di container con Docker e Kubernetes, l'implementazione di microservizi e serverless computing, 
      nonché le best practice per la sicurezza delle applicazioni.  
      Inoltre, ho sviluppato e distribuito applicazioni cloud-native, completando un progetto capstone con la realizzazione di un Software as a Service (SaaS) 
      basato su metodologie cloud.  
      Questa certificazione mi ha fornito un'esperienza pratica in CI/CD, GitHub, OpenShift, Python per Data Science e AI, e nello sviluppo di applicazioni AI con Flask.
    </Typography>
  </CardContent>
</Card>


<Card sx={{ mb: 2 }}>
  <CardContent>
    <Typography variant="h6">Certificazione JavaScript Professional – W3Schools</Typography>
    <Typography variant="body2" color="text.secondary">
      Ho conseguito la certificazione JavaScript Professional rilasciata da W3Schools, che attesta competenze avanzate nello sviluppo con JavaScript moderno.  
      Il percorso ha consolidato la mia conoscenza della programmazione asincrona, gestione del DOM, ES6+, strutture dati, funzioni avanzate e best practice per lo sviluppo di applicazioni web dinamiche.  
      La certificazione conferma la mia capacità di scrivere codice JavaScript efficiente, modulare e orientato alla manutenibilità, applicabile sia in contesti front-end che nell’integrazione con servizi back-end.
    </Typography>
  </CardContent>
</Card>



      <Card sx={{ mb: 2 }}>
  <CardContent>
    <Typography variant="h6">Tirocinio presso X3 Solutions</Typography>
    <Typography variant="body2" color="text.secondary">
      Durante il mio tirocinio presso X3 Solutions, ho lavorato allo sviluppo di un sistema di gestione delle prenotazioni delle postazioni di lavoro. Il progetto è stato realizzato con un'architettura moderna full-stack, utilizzando .NET Core per il back-end 
      e React per il front-end.  
      Ho implementato API REST per la gestione delle prenotazioni e delle risorse, sfruttando Entity Framework per l'interazione con un database MySQL.  
      Inoltre, ho integrato il sistema di autenticazione X3Auth basato su OAuth 2.0 e OpenID Connect, migliorando la sicurezza e la gestione degli accessi.  
      Questa esperienza mi ha permesso di approfondire lo sviluppo web, il design di API scalabili e l'integrazione di sistemi di autenticazione avanzati.
    </Typography>
  </CardContent>
</Card>

<Card sx={{ mb: 2 }}>
  <CardContent>
    <Typography variant="h6">Sviluppatore Software presso Quattroemme</Typography>
    <Typography variant="body2" color="text.secondary">
      Attualmente lavoro nello sviluppo di soluzioni software orientate alla visualizzazione dati e ad applicazioni web interattive ad alta componente grafica.  
      Contribuisco alla progettazione e realizzazione di applicativi seguendo l’intero ciclo di sviluppo, dal wireframing e definizione dell’architettura fino al deployment in ambienti di produzione.  

      Mi occupo dello sviluppo front-end con React per interfacce dinamiche e data-driven, utilizzando librerie grafiche 3D come three.js per la visualizzazione di contenuti tridimensionali nel browser e Mapbox per l’integrazione di mappe interattive.  

      Lavoro anche sullo sviluppo back-end con Node.js e Django, progettando API REST e logiche applicative scalabili, curando l’integrazione tra servizi e la gestione di dati complessi.  
      Questa esperienza mi permette di operare su architetture full stack moderne, approfondendo la progettazione modulare, la gestione del ciclo di vita del software e le pratiche di rilascio e distribuzione delle applicazioni.
    </Typography>
  </CardContent>
</Card>


    </Container>
    );
};

export default Home;
